import { ISelectOption } from '@smartshell/ui-kit';

import { Tax } from 'types';

const serviceNameOptions: ISelectOption[] = [
  {
    title: 'Аренда компьютерного оборудования',
    value: 'Аренда компьютерного оборудования',
  },
  {
    title: 'Аренда игрового места',
    value: 'Аренда игрового места',
  },
  {
    title: 'Игровое время',
    value: 'Игровое время',
  },
];

const taxOption: ISelectOption[] = [
  {
    value: Tax.NONE,
    title: 'Без НДС',
  },
  {
    value: Tax.VAT0,
    title: 'НДС 0%',
  },
  {
    value: Tax.VAT5,
    title: 'НДС 5%',
  },
  {
    value: Tax.VAT7,
    title: 'НДС 7%',
  },
  {
    value: Tax.VAT10,
    title: 'НДС 10%',
  },
  {
    value: Tax.VAT20,
    title: 'НДС 22%',
  },
  {
    value: Tax.VAT110,
    title: 'НДС 110%',
  },
  {
    value: Tax.VAT120,
    title: 'НДС 120%',
  },
];

export { serviceNameOptions, taxOption };
